import { OtherArea } from '@travel/traveler-core/types/areaDetails';
import { Link } from 'core/universalRouter/Link';
import React, { ReactNode } from 'react';

import paths from 'core/universalRouter/paths';

import styles from './otherAreas.module.scss';
import { cx, isNotEmptyArray } from '@travel/utils';

export type AREA_CATEGORY = 'SUBDIVISIONS' | 'CITIES';

type Props = {
  wrapperClassName?: string;
  title: ReactNode;
  type: AREA_CATEGORY;
  otherAreas: OtherArea[];
};

function OtherAreas(props: Props) {
  const otherAreas = props.otherAreas;
  if (!isNotEmptyArray(otherAreas)) {
    return null;
  }

  return (
    <section
      className={cx(styles.sectionWrapper, props.wrapperClassName)}
      data-testid="otherArea-wrapper"
    >
      <h2 className={styles.title} data-testid="otherArea-title">
        {props.title}
      </h2>
      <div className={styles.otherAreasContent} data-testid="otherArea-areaContent">
        {otherAreas.map(otherArea => (
          <OtherAreaLink
            pathId={otherArea.pathId}
            name={otherArea.name}
            type={props.type}
            key={otherArea.pathId}
          />
        ))}
      </div>
    </section>
  );
}

function OtherAreaLink(props: { pathId: string; name: string; type: AREA_CATEGORY }) {
  const linkPath =
    props.type === 'CITIES'
      ? `${paths.providerList.pathResolver(props.pathId)}`
      : `${paths.area.pathResolver(props.pathId)}`;
  return (
    <Link to={linkPath} className={styles.areaLink} data-testid={`otherArea-link-${props.name}`}>
      <div className={styles.areaName}>{props.name}</div>
    </Link>
  );
}

export default OtherAreas;
